module.exports = __webpack_public_path__ + "static/src/content/silks/redzel.b052ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/redzel.png
// module id = aEO1
// module chunks = 0